import { z } from "zod";
import { shiftDays } from "./analytics-scope.ts";
import { localDayStartMs, localToday } from "./local-day.ts";

export const WINDOW_MAX_DAYS = 3_650;

export const WINDOW_PRESET_DAYS = [1, 7, 30, 90, 365] as const;

export const windowDaysSchema = z.number().int().min(1).max(WINDOW_MAX_DAYS).nullable();

export type WindowDays = z.infer<typeof windowDaysSchema>;

export interface WindowSpan {
  readonly firstDay: string | null;
  readonly lastDay: string;
  readonly since: Date | null;
  readonly until: Date;
}

export const windowSpan = (days: WindowDays, timeZone: string, now: Date): WindowSpan => {
  const lastDay = localToday(timeZone, now);
  const firstDay = days === null ? null : shiftDays(lastDay, 1 - days);
  return {
    firstDay,
    lastDay,
    since: firstDay === null ? null : new Date(localDayStartMs(firstDay, timeZone)),
    until: new Date(localDayStartMs(shiftDays(lastDay, 1), timeZone)),
  };
};

export const windowCeiling = (retentionDays: number | null): number =>
  retentionDays === null ? WINDOW_MAX_DAYS : Math.min(retentionDays, WINDOW_MAX_DAYS);

export const beyondRetention = (days: WindowDays, retentionDays: number | null): boolean =>
  days !== null && days > windowCeiling(retentionDays);
